import {createSlice} from "@reduxjs/toolkit";
import {RootState} from "..";


export type LayoutState = {
    drawer: boolean;
    loading: boolean;
    drawerWidth: number;
}


const initialState: LayoutState = {
    drawer: true,
    loading: false,
    drawerWidth: 240,
}


export const layoutSlice = createSlice({
    name: 'layout',
    initialState,
    reducers: {
        setDrawer: (state, action) => {
            state.drawer = action.payload;
        },
        setLoading: (state, action) => {
            state.loading = action.payload;
        },
    },

})


export default layoutSlice.reducer

export const useLayoutActions = layoutSlice.actions;

export const useLayoutState = (state: RootState) => state.layout;